module.exports = __webpack_public_path__ + "static/media/time_tracking_homepage.0ceae840.avif";